export default __webpack_public_path__ + "static/media/SPONSOR-Kiwanis.f01b07eb.svg";